// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YIVrMmioUyMNalDo{border-radius:1000px}.OSC62X8HcUgC1AsJ{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block}.tHNTyRBHiK0PFiKw{display:flex;flex-direction:column;justify-content:center;align-items:center}.bcPkFsOnD94EAXJF{animation:MwqMl39wzU0zna5T 3s infinite;animation-iteration-count:infinite}@keyframes MwqMl39wzU0zna5T{0%{background:var(--py-neutral-1)}30%{background:var(--py-neutral-1)}50%{background:var(--py-neutral-1)}80%{background:var(--py-neutral-1)}100%{background:var(--py-neutral-1)}}._jAIbBQ4P0OxbY1b{display:inline}._jAIbBQ4P0OxbY1b .GaOnLMsYzWkAoAFj{display:inline}._jAIbBQ4P0OxbY1b .n1KbH2oI5FUBGcRx{display:inline-block;height:10px;width:10px;border-radius:30px;vertical-align:middle;margin-right:4px}._jAIbBQ4P0OxbY1b .PsRfhGZzcIYIzkPX{margin-right:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"circle": `YIVrMmioUyMNalDo`,
	"text-truncate": `OSC62X8HcUgC1AsJ`,
	"shaquille": `tHNTyRBHiK0PFiKw`,
	"shimmer": `bcPkFsOnD94EAXJF`,
	"placeHolderShimmer": `MwqMl39wzU0zna5T`,
	"readableOutlookChip": `_jAIbBQ4P0OxbY1b`,
	"outlookEntryContainer": `GaOnLMsYzWkAoAFj`,
	"outlookColor": `n1KbH2oI5FUBGcRx`,
	"outlookName": `PsRfhGZzcIYIzkPX`
};
export default ___CSS_LOADER_EXPORT___;
